import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Slider from '@material-ui/core/Slider'

import { setRakStreetsTransparency } from './AddressingMapView'

const useStyles = makeStyles({
    root: {
      height: 200,
      position :'absolute',
      right : "96px",
      top  : "100px",
      zIndex: 900
    },
  });

const marks = [
    {
        value : 0,
        label :"0%"
    },
    {
        value : 50,
        label : "50%"
    },
    {
        value : 100,
        label : "100%"
    }
]
  
function TranspController(props) {
    const classes = useStyles();

    const handleChange =(evt , newValue)=>{
        console.log(newValue)
        setRakStreetsTransparency(newValue)
    }
    return (
      <div className={classes.root}>
        <Slider 
            orientation="vertical" 
            defaultValue={0} 
            marks={marks} 
            onChange ={handleChange}
            />
      </div>
    );
}

export default TranspController;